import React from 'react'
import { Box, Tooltip } from '@material-ui/core'
import { getStatusColor, getStatusName } from '../lib/utils'
import { EventSeat } from '@material-ui/icons'
import { SeatStatus } from 'config/constants'
import { getDescriptor } from 'views/utils/functions'

function Seat({
  row,
  rowDescriptor,
  column,
  columnDescriptor,
  status,
  userId,
  fullName,
  description,
  identificationType,
  documentNumber,
  onClick,
  onClickSold,
  seatId
}) {
  const handleClick = () => {
    // lógica existente para Available / ToSell
    if (status === SeatStatus.Available) {
      onClick(seatId, row, column, SeatStatus.ToSell, description)
      return
    } else if (status === SeatStatus.ToSell) {
      onClick(seatId, row, column, SeatStatus.Available, description)
      return
    }

    // Nueva lógica: si el asiento es Sold o SoldSelected delegamos en onClickSold
    if (status === SeatStatus.Sold || status === SeatStatus.SoldSelected) {
      // Pasamos los datos del user hacia arriba (pueden ser null/undefined si no hay)
      if (typeof onClickSold === 'function') {
        onClickSold(
          seatId,
          userId ?? null,
          fullName ?? null,
          identificationType ?? null,
          documentNumber ?? null
        )
      }
      return
    }

    // Otros estados: no hacer nada (respeta la lógica existente)
    return
  }

  return (
    <Tooltip
      title={`${
        (status === SeatStatus.Sold || status === SeatStatus.SoldSelected) &&
        userId != null
          ? `${fullName} (${identificationType} ${documentNumber})`
          : `Fila: ${getDescriptor(rowDescriptor, row)}, Columna: ${getDescriptor(columnDescriptor, column)}, Estado: ${getStatusName(status)}`
      }`}>
      <Box
        onClick={handleClick}
        sx={{
          width: 30,
          height: 30,
          overflow: 'hidden',
          border: '1px solid #ccc',
          borderRadius: '4px'
        }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: getStatusColor(status),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor:
              status === SeatStatus.Available ||
              status === SeatStatus.ToSell ||
              status === SeatStatus.Sold ||
              status === SeatStatus.SoldSelected
                ? 'pointer'
                : 'default',
            transition: 'all 0.2s',
            '&:hover': {
              transform: 'scale(1.1)',
              boxShadow: '0 0 5px rgba(0,0,0,0.2)'
            }
          }}>
          {status === SeatStatus.Empty ? (
            ''
          ) : (
            <EventSeat style={{ fontSize: '0.9rem' }} />
          )}
        </Box>
      </Box>
    </Tooltip>
  )
}

export default React.memo(Seat, (prev, next) => prev.status === next.status)
